<template>
  <b-modal
    id="modal-temp-tracker-result"
    ref="modal-temp-tracker-result"
    centered
    :title="$t('liveView.tempTracking.resultTitle')"
  >
    <b-card>
      <p>
        {{ link }}
      </p>
    </b-card>
    <template #modal-footer>
      <b-button size="md" variant="outline-primary" @click="copy()">
        {{ $t('liveView.action.copyLink') }}
      </b-button>
      <b-button size="md" variant="primary" @click="browse()">
        {{ $t('liveView.action.browse') }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { Helper } from '@/mixin/helper'

export default {
  name: 'ModalTempTrackingResult',
  mixins: [Helper],
  props: {
    tempTracking: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseUrl: window.location.origin,
    }
  },
  computed: {
    link() {
      const token = this.tempTracking.shortKey
        ? `shToken=${this.tempTracking.shortKey}`
        : `token=${this.tempTracking.accessToken}`
      return `${this.baseUrl}/fleet/live-track/${this.tempTracking.temporaryLvId}?${token}`
    },
  },
  methods: {
    copy() {
      navigator.clipboard.writeText(this.link)
      this.$mcToast.success(this.$t('global.alert.text.linkCopied'))
    },
    browse() {
      window.open(this.link, '_blank')
    },
  },
}
</script>
